export const getDefaultState = () => {
  return {
    teams: {},
    invitation: null,
    error: null,
    status: null
  }
}
